import { AfterViewInit, Component, input, viewChild } from '@angular/core';
import { jqxSwitchButtonComponent, jqxSwitchButtonModule } from 'jqwidgets-ng/jqxswitchbutton';
import { AppComponent } from 'src/app/app.component';
import { IPlugin } from 'src/app/interfaces/IPlugin';
import { PluginsManager } from 'src/app/managers/plugins.manager';

@Component({
  selector: 'app-plugin-card',
  standalone: true,
  imports: [
    jqxSwitchButtonModule
  ],
  templateUrl: './plugin-card.component.html',
  styleUrl: './plugin-card.component.css',
})
export class PluginCardComponent implements AfterViewInit {
  protected pluginSwitchButton = viewChild<jqxSwitchButtonComponent>('pluginSwitchButton')

  protected title = input.required<string>();
  protected description = input.required<string>();
  protected imageSrc = input.required<string>();

  protected checked: boolean;

  public constructor(
    private pluginsManager: PluginsManager
  ) {}

  public ngAfterViewInit(): void {
    if (this.isChecked(this.title())) {
      this.pluginSwitchButton().check();
    }
    else {
      this.pluginSwitchButton().uncheck();
    }
  }

   protected translate(text: string): string {
      return AppComponent.translate(text);
  }

  public isChecked(pluginName: string): boolean {
    if (this.pluginsManager.isPluginActive(pluginName)) {
      return true;
    }
    return false;
  }

  public Checked(pluginName: string): void {
    this.pluginsManager.activatePlugin(pluginName);
  }

  public Unchecked(pluginName: string): void {
    this.pluginsManager.deactivatePlugin(pluginName);
  }
}
